export { authenticate, autoAuthenticate, deauthenticate } from "./actions";
export { default as reducer } from "./reducer";

import { AuthState as TAuthState } from "./types";
export type AuthState = TAuthState;
